(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dd-quiz')) {
    class DDQuiz extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.screens = Array.from(this.querySelectorAll('[data-screen]'));
        this.currentIndex = Math.max(0, this.screens.findIndex((screen) => screen.classList.contains('is-active')));
        this.answers = this.readStoredAnswers();
        this.resultDefinitions = this.readResultDefinitions();
        this.bindEvents();
        this.handleBlockSelect = (event) => {
          const resultMarker = event.target.closest('[data-result-editor-block]');
          if (resultMarker && this.contains(resultMarker)) {
            const selectedResult = this.resultDefinitions.find((result) => result.id === resultMarker.dataset.resultEditorBlock);
            if (selectedResult) this.applyResult(selectedResult);
          }
          const screen = event.target.closest('[data-screen]');
          if (!screen || !this.contains(screen)) return;
          const index = this.screens.indexOf(screen);
          if (index >= 0) this.show(index, false);
        };
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.querySelector('[data-capture-success]')) {
          this.showResult();
          this.cleanSuccessfulFormUrl();
        } else {
          this.show(this.currentIndex, false);
        }
      }

      disconnectedCallback() {
        if (this.handleBlockSelect) document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      bindEvents() {
        this.addEventListener('click', (event) => {
          const start = event.target.closest('[data-start]');
          const next = event.target.closest('[data-next]');
          const back = event.target.closest('[data-back]');
          const skip = event.target.closest('[data-skip]');
          if (start) {
            this.answers = {};
            this.clearStoredAnswers();
            this.show(this.currentIndex + 1);
          }
          if (next && !next.disabled) this.show(this.currentIndex + 1);
          if (back) this.show(this.currentIndex - 1);
          if (skip) this.showResult();
        });

        this.addEventListener('change', (event) => {
          const answer = event.target.closest('[data-answer-index]');
          if (answer) {
            const screen = answer.closest('[data-question]');
            const question = screen.dataset.question;
            this.answers[question] = Number(answer.dataset.answerIndex);
            this.storeAnswers();
            const next = screen.querySelector('[data-next]');
            if (next) next.disabled = false;
          }
        });

        const form = this.querySelector('.dd-quiz__capture-form');
        if (form) form.addEventListener('submit', (event) => this.submitCapture(event));
      }

      show(index, focus = true) {
        const nextIndex = Math.max(0, Math.min(this.screens.length - 1, index));
        this.screens.forEach((screen, screenIndex) => {
          const active = screenIndex === nextIndex;
          screen.hidden = !active;
          screen.classList.toggle('is-active', active);
          screen.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.currentIndex = nextIndex;
        const current = this.screens[this.currentIndex];
        if (focus) {
          const heading = Array.from(current.querySelectorAll('h1[tabindex], h2[tabindex]')).find((element) => element.getClientRects().length > 0);
          if (heading) heading.focus({ preventScroll: true });
          this.scrollIntoView({ behavior: this.reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        }
      }

      reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      answerStorageKey() {
        return `dd-quiz-answers-${this.dataset.sectionId || this.id}`;
      }

      readStoredAnswers() {
        try {
          const storedAnswers = JSON.parse(sessionStorage.getItem(this.answerStorageKey()) || '{}');
          return storedAnswers && typeof storedAnswers === 'object' ? storedAnswers : {};
        } catch (error) {
          return {};
        }
      }

      storeAnswers() {
        try {
          sessionStorage.setItem(this.answerStorageKey(), JSON.stringify(this.answers));
        } catch (error) {
          /* The quiz still works when session storage is unavailable. */
        }
      }

      clearStoredAnswers() {
        try {
          sessionStorage.removeItem(this.answerStorageKey());
        } catch (error) {
          /* No cleanup is needed when session storage is unavailable. */
        }
      }

      cleanSuccessfulFormUrl() {
        if (!window.history?.replaceState) return;
        const url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        if (url.hash === `#${this.querySelector('.dd-quiz__capture-form')?.id}`) url.hash = '';
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      }

      readResultDefinitions() {
        const resultsNode = this.querySelector('[data-dd-quiz-results]');
        if (!resultsNode) return [];
        try {
          const results = JSON.parse(resultsNode.textContent);
          return Array.isArray(results) ? results : [];
        } catch (error) {
          return [];
        }
      }

      parseAnswerMap(answerMap) {
        return String(answerMap || '')
          .split(',')
          .map((answerCode) => answerCode.trim().toUpperCase().replace(/\s+/g, ''))
          .filter((answerCode) => /^Q\d+_A\d+$/.test(answerCode));
      }

      matchingResult() {
        if (!this.resultDefinitions.length) return null;
        const selectedAnswers = new Set(
          Object.entries(this.answers).map(([question, answer]) => `Q${question}_A${answer}`)
        );
        let bestResult = null;
        let bestScore = 0;
        let fallbackResult = null;

        this.resultDefinitions.forEach((result) => {
          const mappedAnswers = this.parseAnswerMap(result.answer_map);
          if (!mappedAnswers.length) {
            if (!fallbackResult) fallbackResult = result;
            return;
          }
          const score = mappedAnswers.reduce(
            (total, answerCode) => total + (selectedAnswers.has(answerCode) ? 1 : 0),
            0
          );
          if (score > bestScore) {
            bestScore = score;
            bestResult = result;
          }
        });

        return bestResult || fallbackResult || this.resultDefinitions[0];
      }

      applyResult(result) {
        if (!result) return;
        this.dataset.resultId = result.id || '';
        this.querySelectorAll('[data-result-eyebrow]').forEach((node) => { node.textContent = result.eyebrow || ''; });
        this.querySelectorAll('[data-result-heading]').forEach((node) => { node.textContent = result.heading || ''; });
        this.querySelectorAll('[data-result-body]').forEach((node) => { node.textContent = result.body || ''; });
        this.querySelectorAll('[data-result-outcome]').forEach((node) => { node.innerHTML = result.outcome || ''; });

        if (result.testimonial_quote) {
          this.querySelectorAll('[data-testimonial-quote]').forEach((node) => { node.textContent = `"${result.testimonial_quote}"`; });
        }
        if (result.testimonial_name) {
          this.querySelectorAll('[data-testimonial-name]').forEach((node) => { node.textContent = result.testimonial_name; });
        }
        if (result.testimonial_meta) {
          const metaParts = result.testimonial_meta.split(' · ');
          const status = metaParts[0] || '';
          const reach = metaParts.length > 1 ? metaParts.slice(1).join(' · ') : '';
          this.querySelectorAll('[data-testimonial-status]').forEach((node) => { node.textContent = status; });
          this.querySelectorAll('[data-testimonial-reach]').forEach((node) => {
            node.textContent = reach;
            node.hidden = !reach;
          });
          this.querySelectorAll('[data-testimonial-separator]').forEach((node) => { node.hidden = !reach; });
        }
      }

      async submitCapture(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const email = form.querySelector('input[type="email"]');
        const error = form.querySelector('[role="alert"]');
        const submitButton = form.querySelector('[type="submit"]');
        if (form.dataset.submitting === 'true') return;
        if (!email.checkValidity()) {
          email.setAttribute('aria-invalid', 'true');
          error.textContent = error.dataset.emailError || error.textContent;
          error.hidden = false;
          email.focus();
          return;
        }
        email.removeAttribute('aria-invalid');
        error.hidden = true;
        const tags = form.querySelector('[data-quiz-tags]');
        if (tags) tags.value = `dd-quiz,dd-quiz-q1-a${this.answers[1] || 0},dd-quiz-q2-a${this.answers[2] || 0},dd-quiz-q3-a${this.answers[3] || 0},dd-quiz-q4-a${this.answers[4] || 0}`;
        this.storeAnswers();
        form.dataset.submitting = 'true';
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' },
            credentials: 'same-origin',
            redirect: 'follow'
          });
          if (!response.ok) throw new Error('Customer form request failed');

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseForm = responseDocument.getElementById(form.id);
          if (!responseForm || !responseForm.querySelector('[data-capture-success]')) {
            const serverErrors = responseForm?.querySelector('[data-capture-server-errors]')?.textContent.trim();
            throw new Error(serverErrors || 'Customer form was not verified');
          }

          this.showResult();
        } catch (submissionError) {
          error.textContent = submissionError.message && submissionError.message !== 'Customer form was not verified' && submissionError.message !== 'Customer form request failed'
            ? submissionError.message
            : (error.dataset.submitError || 'We could not verify your email. Please try again.');
          error.hidden = false;
          email.setAttribute('aria-invalid', 'true');
          email.focus();
        } finally {
          form.dataset.submitting = 'false';
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        }
      }

      showResult() {
        this.applyResult(this.matchingResult());
        this.clearStoredAnswers();
        const resultIndex = this.screens.findIndex((screen) => screen.dataset.screen === 'result');
        this.show(resultIndex);
      }

    }
    customElements.define('dd-quiz', DDQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
